<template>
  <div class="ListOverflowContainer">
    <div
      ref="listContainer"
      class="ListOverflowContainer-MaxHeightWrapper"
      :style="{ 'max-height': computedMaxHeight, visibility: visibility }"
    >
      <div
        class="gradient top"
        v-if="overflown"
        :style="{ opacity: gradient_top_opacity }"
      ></div>
      <div
        class="gradient bottom"
        v-if="overflown"
        :style="{ opacity: gradient_bottom_opacity }"
      ></div>
      <slot name="default"></slot>
    </div>
  </div>
</template>

<script>
import { smoothScroll } from "@/utils/smoothScrool";

export default {
  name: "ListOverflowScroll",
  data() {
    return {
      overflown: false,
      gradient_top_opacity: 1.0,
      gradient_bottom_opacity: 1.0,
      visibility: "hidden"
    };
  },
  props: {
    maxListHeight: {
      type: Number,
      default: 1200
    }
  },
  created() {
    setTimeout(this.checkOverflown, 0);
  },
  computed: {
    computedMaxHeight() {
      return this.maxListHeight + "px";
    }
  },
  methods: {
    checkOverflown() {
      if (typeof this.$refs.listContainer === "undefined") {
        this.overflown = false;
        return;
      }
      let elem = this.$refs.listContainer;
      elem.removeEventListener("scroll", this.scroll);
      this.overflown = elem.scrollHeight > elem.clientHeight;
      if (this.overflown) {
        elem.addEventListener("scroll", this.scroll);
        this.gradient_bottom_opacity = 1.0;
        this.gradient_top_opacity = 1.0;
        setTimeout(() => {
          this.scroll(undefined);
          this.scrollBottomToTop();
        }, 0);
      }
      this.$refs.listContainer.scrollTo(0, 0);
      this.visibility = "visible";
    },
    scroll(event) {
      let elem = this.$refs.listContainer;
      let distance_from_bottom =
        elem.scrollHeight - (elem.clientHeight + elem.scrollTop);
      let bottom_multiplier =
        distance_from_bottom > 300 ? 1.0 : distance_from_bottom + 1 / 300.0;
      this.gradient_bottom_opacity = bottom_multiplier;
      let top_multiplier =
        elem.scrollTop > 300 ? 1.0 : elem.scrollTop + 1 / 300.0;
      this.gradient_top_opacity = top_multiplier;
    },
    scrollBottomToTop() {
      const TIMEOUT_BEFORE_SCROLL_START = 250;
      const SCROLL_DURATION = 1250;
      let listContainerDiv = this.$refs.listContainer;
      let scrollTo =
        listContainerDiv.scrollHeight - listContainerDiv.clientHeight;
      listContainerDiv.scrollTop = scrollTo;
      setTimeout(() => {
        smoothScroll(0, SCROLL_DURATION, listContainerDiv);
      }, TIMEOUT_BEFORE_SCROLL_START);
    }
  }
};
</script>

<style scoped>
.ListOverflowContainer {
  position: relative;
}

.ListOverflowContainer-MaxHeightWrapper {
  overflow: scroll;
}

.gradient {
  transition: opacity 0.5s ease;
  z-index: 5;
  position: absolute;
  pointer-events: none;
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gradient.top {
  top: -3px;
  background: linear-gradient(180deg, var(--app_color_background), transparent);
}
.gradient.bottom {
  bottom: -3px;
  background: linear-gradient(0deg, var(--app_color_background), transparent);
}
</style>
